// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { jettingAppViewStyles } from "@stoneage/App/Widgets/JettingAppView/JettingAppView";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

jettingAppViewStyles.tabs = {
    cssOverrides: {
        tabGroup: css`
            overflow: visible;
            min-height: 30px;
            z-index: 2;
            &::after {
                bottom: 0;
            }
        `,
        tabContent: css`
            margin-top: 20px;
            padding: 0;
        `,
        wrapper: css`
            & > div {
                position: relative;
            }
        `,
    },
};

jettingAppViewStyles.tab = {
    color: "secondary.main",
    css: css`
        &&& {
            font-size: 15px;
            line-height: 18px;
            height: 30px;
            padding-top: 0;
            padding-bottom: 12px;
            &:last-child {
                padding-right: 0;
            }

            &:after {
                bottom: 1px;
                height: 4px;
            }
            &:hover,
            &:focus {
                &:after {
                    height: 4px;
                }
            }

            &:focus,
            &:active {
                &:after {
                    bottom: 1px;
                    height: 4px;
                }
            }

            [class*="TooltipTriggerer"][aria-expanded="true"] {
                [class*="IconWrapper"] {
                    transform: rotate(-180deg);
                    transition: 0.2s;

                    svg {
                        color: ${color("secondary")} !important;
                    }
                }
            }
        }
    `,
};
jettingAppViewStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    `,
};

jettingAppViewStyles.calculatorTitle = {
    variant: "h3",
    forwardAs: "h1",
    css: css`
        margin-bottom: 20px;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
jettingAppViewStyles.dropDownWrapper = {
    css: css`
        margin-bottom: 16px;
        width: 50%;
        ${xScreen("lt", "sm")} {
            width: calc(100% - 124px);
        }
    `,
};

jettingAppViewStyles.downIcon = {
    size: 16,
    color: "common.ui6",
    css: css`
        margin-right: 0;
    `,
};
jettingAppViewStyles.tooltipLinkWrapper = {
    css: css`
        display: flex;
        text-align: left;
        &:not(:last-child) {
            margin-bottom: 12px;
        }
    `,
};
jettingAppViewStyles.tooltipLink = {
    typographyProps: {
        color: "text",
        css: css`
            &&& {
                color: ${color("text.main")};
            }
        `,
    },
    css: css`
        &&&:hover ${TypographyStyle}, &&&:focus ${TypographyStyle} {
            color: ${color("text.link")};
        }
    `,
};
jettingAppViewStyles.viewWrapper = {
    css: css`
        position: relative;
        margin-bottom: 16px;
    `,
};

jettingAppViewStyles.errorMessage = {
    css: css`
        margin-bottom: 16px;
    `,
};
